const transformer = function (origin, defs, rowData, fields, hooks) {
  const onClickOpenDetail = hooks.showTbDetail
  const onClickUpdateData = hooks.createTbData
  const onClickDestroyData = hooks.destroyTbData
    ? () => {
        return hooks.destroyTbData(rowData.objectId)
      }
    : null
  const onClickRecoveryData = hooks.recoverTbData
    ? () => {
        return hooks.recoverTbData(rowData.objectId)
      }
    : null
  return {
    render: 'operate',
    origin,
    value: origin,
    fields,
    rowData,
    onClickOpenDetail,
    onClickUpdateData,
    onClickDestroyData,
    onClickRecoveryData,
  }
}

export default transformer
